import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(() => ({
  root: {},
  fields: {
    // we're controling the grid's row spacing
    // because HvGrid still doesn't support it to
    // be different from the column spacing.
    "$root &>div": {
      paddingTop: 5,
      paddingBottom: 0,
    },
  },
  input: {
    height: 86,
  },
  gridPaddingOverRide: {
    padding: "0 15px",
  },
}));

export default useStyles;
